"use client";
import ReactTimeAgo from "react-time-ago";
import Link from "next/link";
import Image from "next/image";
import RelativeTime from "../relative-time";
import React, { useRef } from "react";

interface article {
  attributes: {
    title: string;
    league: string;
    image: any;
    publishedAt: string;
    slug: string;
  };
}

export default function FeaturedNews({ articles }: { articles: article[] }) {
  return (
    <div className="grid grid-cols-1 desktop-news:grid-cols-2 desktop-grid:grid-cols-2 gap-4">
      {articles?.map((article, index) => {
        const { title, league, publishedAt, image, slug } = article.attributes;
        const thumbnailUrl =
          image?.data?.attributes.formats?.medium.url ||
          image?.data?.attributes.url;
        return (
          <Link
            href={`/news/${slug}`}
            prefetch={false}
            key={index}
            className="flex flex-col gap-2 bg-white rounded-xl shadow-card relative"
          >
            <div className="image overflow-hidden rounded-xl">
              <Image
                src={thumbnailUrl}
                unoptimized
                width={364}
                height={260}
                alt={title}
                className="w-full aspect-video h-[260px] object-cover"
              />
              <div className="absolute inset-0 z-10 flex items-start flex-col bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.6)_100%)] bg-cover bg-center bg-no-repeat rounded-xl">
                <div className="px-6 py-5 flex flex-col gap-2 items-start justify-between h-full">
                  {/* Turn into component */}
                  <div className="flex gap-1 h-7 items-center text-title-sm-medium text-secondary-700 px-2 py-3 rounded-xl bg-[rgba(255,255,255,0.15)] backdrop-blur-[15.25px]">
                    <div>{league}</div>
                    <div>•</div>
                    <div>
                      <RelativeTime short date={publishedAt} />
                    </div>
                  </div>
                  <div className="text-headline-lg uppercase text-white font-bold">
                    {title}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
